import "./App.css";
import "@mantine/core/styles.css";
import { createTheme, MantineProvider } from "@mantine/core";
import { QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router";
import { queryClient } from "../lib/query-client.ts";
import { Router } from "./Router.tsx";

const theme = createTheme({
	fontFamily: "Lato",
	primaryColor: "gray",
	black: "#131212",
	defaultRadius: "0.125rem",
});

export function App(): React.JSX.Element {
	return (
		<QueryClientProvider client={queryClient}>
			<MantineProvider theme={theme}>
				<BrowserRouter>
					<Router />
				</BrowserRouter>
			</MantineProvider>
		</QueryClientProvider>
	);
}
